  <app-brand-header #header [brandProfile]="brandProfile" [pageContent]="pageContent" [isLogoutVisible]="isLogoutVisible"> </app-brand-header>
  <main class="dsb-cards-container">
      <div *ngFor="let dsbOccurrence of dsbOccurrences">
        <app-disbursement-occurrence [fundingAccounts]="fundingAccounts" [dsbOccurrence]="dsbOccurrence" (disbursedFunds)="disbursedFundsHandler($event)" ></app-disbursement-occurrence>
      </div>
  </main>
